import styled, { css } from 'styled-components';

/**
 * Tag component for displaying skills, categories, etc.
 * Usage:
 * <Tag>JavaScript</Tag>
 * <Tag color="primary">React</Tag>
 * <Tag color="secondary">Node.js</Tag>
 */
const Tag = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 0.3rem 0.8rem;
  border-radius: 16px;
  font-size: 0.75rem;
  font-weight: 500;
  margin-right: 0.5rem;
  margin-bottom: 0.5rem;
  
  ${props => {
    switch(props.color) {
      case 'primary':
        return css`
          background-color: rgba(66, 133, 244, 0.1);
          color: #4285F4;
          border: 1px solid rgba(66, 133, 244, 0.2);
        `;
      case 'secondary':
        return css`
          background-color: rgba(95, 99, 104, 0.1);
          color: #5F6368;
          border: 1px solid rgba(95, 99, 104, 0.2);
        `;
      case 'success':
        return css`
          background-color: rgba(15, 157, 88, 0.1);
          color: #0F9D58;
          border: 1px solid rgba(15, 157, 88, 0.2);
        `;
      case 'warning':
        return css`
          background-color: rgba(244, 180, 0, 0.1);
          color: #F4B400;
          border: 1px solid rgba(244, 180, 0, 0.2);
        `;
      case 'danger':
        return css`
          background-color: rgba(219, 68, 55, 0.1);
          color: #DB4437;
          border: 1px solid rgba(219, 68, 55, 0.2);
        `;
      case 'info':
        return css`
          background-color: rgba(66, 133, 244, 0.1);
          color: #4285F4;
          border: 1px solid rgba(66, 133, 244, 0.2);
        `;
      default:
        return css`
          background-color: #E8F0FE;
          color: #4285F4;
          border: 1px solid #E8F0FE;
        `;
    }
  }}
  
  ${props => props.removable && css`
    padding-right: 0.4rem;
    
    &::after {
      content: "×";
      margin-left: 0.4rem;
      font-size: 1rem;
      cursor: pointer;
    }
    
    &:hover::after {
      color: #DB4437;
    }
  `}
  
  ${props => props.size === 'small' && css`
    padding: 0.2rem 0.5rem;
    font-size: 0.65rem;
  `}
  
  ${props => props.size === 'large' && css`
    padding: 0.4rem 1rem;
    font-size: 0.85rem;
  `}
`;

export const TagGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 1rem;
`;

export default Tag;
